import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycElderAbusePage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-elder-abuse/']} />;
}
